import React from 'react';
import { CanvasJSChart } from 'canvasjs-react-charts';
import { useTranslation } from 'react-i18next';

const PieChart = ({ countOn, countOff }) => {
  const total = countOn + countOff;
  const { t } = useTranslation();

  const options = {
    exportEnabled: true,
    animationEnabled: true,
    legend: {
      fontFamily: 'Arial',
    },
    toolTip: {
      fontFamily: 'Arial',
    },
    data: [
      {
        type: 'pie',
        startAngle: 180,
        toolTipContent: '{label}: {y}%',
        showInLegend: 'true',
        legendText: '{label}',
        indexLabelFontSize: 14,
        indexLabel: '{label} {y}%',
        indexLabelFontFamily: 'Arial',
        dataPoints: [
          { y: (countOn / total) * 100, label: `${t('online')}` },
          { y: (countOff / total) * 100, label: `${t('offline')}` },
        ],
      },
    ],
  };

  return <CanvasJSChart options={options} />;
};

export default PieChart;
